module.exports = __webpack_public_path__ + "static/blaklader-3c08a74ea17fb5c1aa1509f695b01d50.png";